import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import classnames from 'classnames';
import { translate } from '@securitize/ui-components/i18n/Translate';
import Translate from '@securitize/ui-components/i18n/Translate/Translate';
import { Button } from 'reactstrap';
import MainTitle from '../../../components/MainTitle/MainTitle';
import { getOpportunities } from './actions';
import OpportunityCard from './components/OpportunityCard';
import VerificationBar from '../../../../../components/VerificationBar';
import SecuritizePage from '../../../../../components/SecuritizePage';
import emptyPortfolioImg from './empty-portfolio.svg';
import gridViewImg from '../../../../../assets/img/other/grid-view.svg';
import gridViewSelectedImg from '../../../../../assets/img/other/grid-view-selected.svg';
import rowViewImg from '../../../../../assets/img/other/row-view.svg';
import rowViewSelectedImg from '../../../../../assets/img/other/row-view-seleced.svg';
import './OpportunitiesPage.scss';

const OpportunitiesPage = (props) => {
  const {
    issuerConfig, getOpportunities, isError, isLoading, opportunities,
  } = props;

  useEffect(() => {
    if (opportunities && !opportunities.length) {
      getOpportunities();
    }
  }, []);

  const history = useHistory();

  const [isGridViewMode, setIsGridViewMode] = useState(false);

  return (
    <SecuritizePage
      isLoading={isLoading}
      isError={isError}
    >
      <div className="opportunities position-relative animated fadeIn">
        <MainTitle
          title={translate('Texts.investment-opportunities', { issuerName: issuerConfig.issuerName })}
          className="mb-3"
        />
        <VerificationBar />
        <div className="d-flex align-items-center flex-row-reverse my-3 hide-mobile">
          <Button
            id="btn-save"
            className="m-0 p-0 text-white font-16 box-shadow"
            color="link"
            size="sm"
            onClick={() => setIsGridViewMode(true)}
          >
            <img width="25px" alt="grid view" src={isGridViewMode ? gridViewSelectedImg : gridViewImg} />
          </Button>
          <Button
            id="btn-save"
            className="m-0 p-0 text-white font-16 mr-2 box-shadow"
            color="link"
            size="sm"
            onClick={() => setIsGridViewMode(false)}
          >
            <img width="25px" alt="row view" src={isGridViewMode ? rowViewImg : rowViewSelectedImg} />
          </Button>
        </div>
        {
          opportunities.length
            ? (
              <div className={classnames('opportunities__container', {
                opportunities__container__grid: isGridViewMode,
              })}
              >
                {opportunities.map((opportunity) => (
                  <OpportunityCard
                    key={opportunity.id}
                    opportunity={opportunity}
                    onOpportunitySelect={() => history.push(`/opportunity/${opportunity.id}`)}
                    isGridView={isGridViewMode}
                  />
                ))}
              </div>
            )
            : (
              <div className="mt-5 d-flex justify-content-center align-items-center flex-column">
                <div className="mb-5 font-20">
                  <Translate translationKey="Texts.no-opportunities" />
                </div>
                <img src={emptyPortfolioImg} alt="empty-portfolio-img" />
              </div>
            )
        }
      </div>
    </SecuritizePage>
  );
};

OpportunitiesPage.defaultProps = {
  getOpportunities: () => null,
  isError: false,
  isLoading: false,
  opportunities: [],
  issuerConfig: {},
};

OpportunitiesPage.propTypes = {
  issuerConfig: PropTypes.objectOf(PropTypes.any),
  getOpportunities: PropTypes.func,
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  opportunities: PropTypes.arrayOf(PropTypes.any),
};

const mapStateToProps = (state) => {
  const { auth: { user }, issuerConfiguration, investment: { opportunities } } = state;
  return {
    verificationStatus: (user && user.verificationStatus) || 'not-verified',
    issuerConfig: issuerConfiguration.config,
    isError: opportunities.isError,
    isLoading: opportunities.isLoading,
    opportunities: opportunities.data,
  };
};

export default connect(
  mapStateToProps,
  {
    getOpportunities,
  },
)(OpportunitiesPage);
